import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEpeQueries } from '../../../../../../../../../config/react-query/epe.query';
import { Button, Icon, ResponsiveText } from '../../../../../../../../core';
import DeleteEpeModal from '../modals/delete-epe-modal/delete-epe-modal';
import DeleteEpeWithObservationsModal from '../modals/delete-epe-with-observations/delete-epe-with-observations';
import './dl-delete-epe.scss';

/**
 * Renders delete mission button and popup confirmation
 * @param {Object} props
 * @param {String} props.className
 * @param {String} props.driveLogId
 * @param {String} props.missionCode
 * @param {String} props.updateDriveLogMissions
 */
const DlDeleteEpe = (props) => {
	const { className = '', hasObservations = false, driveLogId = '', missionId = '' } = props;

	const { t } = useTranslation();

	const [showDeletePopup, setShowDeletePopup] = useState(false);
	const [showDeletePopupWithObservations, setShowDeletePopupWithObservations] = useState(false);
	const [epeToDelete, setEpeToDelete] = useState();
	const { deleteEpe } = useEpeQueries();

	const handleShowDeletePopup = (id) => {
		if (hasObservations) setShowDeletePopupWithObservations(true);
		else setShowDeletePopup(true);
		setEpeToDelete(id);
	};

	const handleDeleteEpe = () => {
		deleteEpe.mutate({ id: epeToDelete, driveLogId: driveLogId });
	};

	const handleCancelDeleteEpe = () => {
		setShowDeletePopup(false);
		setEpeToDelete(undefined);
	};

	return (
		<div className={`dl-mission-list__mission__delete ${className}`}>
			<Button
				onClick={() => handleShowDeletePopup(missionId)}
				className="dl-mission-list__mission__delete__btn"
			>
				<Icon name="close" className="dl-mission-list__mission__delete__icon" />
				<ResponsiveText
					text=""
					mobileText={t('dl:dl-detail-page.delete')}
					className="dl-mission-list__mission__delete__text"
				/>
			</Button>

			<DeleteEpeModal
				showModal={showDeletePopup}
				setShowModal={setShowDeletePopup}
				handleDeleteEpe={handleDeleteEpe}
				handleCancelDeleteEpe={handleCancelDeleteEpe}
			/>
			<DeleteEpeWithObservationsModal
				showModal={showDeletePopupWithObservations}
				setShowModal={setShowDeletePopupWithObservations}
			/>
		</div>
	);
};

DlDeleteEpe.propTypes = {
	className: PropTypes.string,
	updateDriveLogMissions: PropTypes.func,
	driveLogId: PropTypes.string,
	missionId: PropTypes.string,
};

export default DlDeleteEpe;
